<template>
  <v-container>
    <v-btn-toggle
      v-model="selectedPage"
      mandatory
      class="d-flex  justify-center"
      ><v-btn v-for="page in pages" v-bind:key="page">{{
        page
      }}</v-btn></v-btn-toggle
    >
    <Quiz v-if="selectedPage == 0"></Quiz>
    <edit-topics v-show="selectedPage == 2"></edit-topics>
    <add-passage v-show="selectedPage == 2"></add-passage>
    <add-question v-show="selectedPage == 1"></add-question>
  </v-container>
</template>

<script>
import AddQuestion from "../components/AddQuestion";
import AddPassage from "../components/AddPassage";
import EditTopics from "../components/EditTopics";
import Quiz from "../components/Quiz";
export default {
  name: "Welcome",
  components: { Quiz, EditTopics, AddQuestion, AddPassage },
  data: () => ({
    pages: ["Quiz", "Add Questions", "Add Other"],
    selectedPage: "Quiz"
  })
};
</script>

<style scoped></style>
